<div ngbDropdown>
  <button ngbDropdownToggle type="button" class="btn btn-secondary" aria-label="Dropdown button">
    {{ currentLanguage().toUpperCase() }}
  </button>

  <div ngbDropdownMenu class="dropdown-menu">
    <button ngbDropdownItem type="button" (click)="languageService.changeLanguage('nl')">NL</button>
    <button ngbDropdownItem type="button" (click)="languageService.changeLanguage('fr')">FR</button>
  </div>
</div>
